import type {
  ChartSelectorConfig,
  SavedQueryDataType,
  SlotRole,
} from '@revelio/core';

import { dashMetaJson } from '../../../shared/api/dash-meta-fetch';

export type SavedQueryFieldDto = {
  name: string;
  type: 'string' | 'number' | 'string[]' | 'number[]';
  description?: string;
  required?: boolean;
  selectionLevelIds?: string[];
  fieldGroup?: string;
  extractMode?: 'id' | 'levelName';
  slotRole?: SlotRole;
  compatibleFilterIds?: string[];
};

export type SavedQueryDto = {
  id: string;
  name: string;
  description?: string;
  queryString?: string;
  fields: SavedQueryFieldDto[];
  dataType: SavedQueryDataType;
  reportId?: string;
  metricId?: string;
  selectorOverrides?: Partial<ChartSelectorConfig>;
};

export type ExecuteSavedQueryFieldValue = string | number | string[] | number[];

export const getSavedQueries = () =>
  dashMetaJson<SavedQueryDto[] | undefined>(
    '/api/custom-query/saved/report-builder',
    { method: 'GET' }
  );

/** Full record including `queryString` (admin-only on dash-meta). */
export const getSavedQueryById = (savedQueryId: string) =>
  dashMetaJson<SavedQueryDto | undefined>(
    `/api/custom-query/saved/${encodeURIComponent(savedQueryId)}`,
    { method: 'GET' }
  );

export const executeSavedQuery = (
  savedQueryId: string,
  fieldValues: Record<string, ExecuteSavedQueryFieldValue>
) =>
  dashMetaJson<unknown[] | undefined>('/api/custom-query/execute-saved', {
    method: 'POST',
    body: JSON.stringify({ savedQueryId, fieldValues }),
  });
